module.exports = __webpack_public_path__ + "static/media/P919news.68e551de.jpg";